import styled from 'styled-components';

import { DeviceTypeWrapper } from 'containers/Devices/components/DeviceTypeCell/styles';

export const UnassignContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  margin-bottom: 8px;

  hover: none;
`;

export const ListItemWrapper = styled(DeviceTypeWrapper)<{
  disableHover?: boolean;
}>`
  height: 32px;
  cursor: default;
  padding-left: 16px;
  margin: 4px 0px 4px 0px;

  ${(props) =>
    !props.disableHover
      ? `:hover {
        background-color: ${props.theme.palette.divider};
        border-radius: 16px;
        border: 1px solid ${props.theme.palette.divider};
      }
      :hover > * {
        background-color: transparent;
        border: none;
      }`
      : ''};
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.palette.grey[200]};
  border-radius: 64px;
`;
